"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiLinkedin = function IconUiLinkedin(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M6.546 15.146h7.584v24.396H6.546zm-.594-7.721a4.23 4.23 0 0 0 1.279 3.107 4.232 4.232 0 0 0 3.107 1.279 4.385 4.385 0 0 0 3.152-1.279 4.23 4.23 0 0 0 1.279-3.107 4.23 4.23 0 0 0-1.279-3.107 4.385 4.385 0 0 0-3.152-1.279 4.232 4.232 0 0 0-3.107 1.279 4.23 4.23 0 0 0-1.279 3.107zm36.594 18.731q0-5.574-1.645-8.269-2.147-3.335-7.447-3.335a8.324 8.324 0 0 0-4.568 1.279 6.992 6.992 0 0 0-2.6 2.65h-.137v-3.335h-7.223v24.4h7.538V27.527a9.344 9.344 0 0 1 .777-4.34 3.976 3.976 0 0 1 3.792-1.965 3.341 3.341 0 0 1 3.426 2.193 12.742 12.742 0 0 1 .5 4.249v11.878h7.584z"
  }));
};

IconUiLinkedin.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiLinkedin;
exports.default = _default;